import { Routes } from '@angular/router';
import { authGuard } from './core/guard/auth.guard';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'assets',
        pathMatch: 'full'
      },
      {
        path: 'assets',
        loadComponent: () => import('./components/assets/assets.component').then(m => m.AssetsComponent),
        children: []
      },
      {
        path: 'dummy',
        loadComponent: () => import('./components/dummy/dummy.component').then(m => m.DummyComponent),
        children: []
      }
    ],
  },
];
